import { Component, Output, EventEmitter } from '@angular/core';
import * as paper from 'paper';

// import {UinumberComponent} from '../uinumber/uinumber'

import { Events } from 'ionic-angular';

//var mypaper: any;
var path: any;
var drag = false;
var papercanvas: HTMLCanvasElement;

enum InputType {
  MOUSE,
  TOUCH,
}

@Component({
  selector: 'uipaper',
  templateUrl: 'uipaper.html'
})
export class UipaperComponent {

 @Output() strokeAdded: EventEmitter<string> = new EventEmitter<string>();

  inputtyp = InputType.TOUCH;
  public textname: string= 'mytext';

  constructor(public myevents: Events) {
    console.log('Hello UipaperComponent Component');

  }

  ngOnInit() {
    console.log("ngOnInit uitextpaint");
    this.initPaper();

this.testthings();
  }

  

  initPaper() {
    
    papercanvas = <HTMLCanvasElement>document.getElementById('myuipaper');
    //alert(mycanvas.id)
    // paper.install(window);
    paper.setup(papercanvas);
this.initpapercanvas();
    this.addEvents();

    this.testthings();
  }

  initpapercanvas(){
    // papercanvas.width = 300;
    // papercanvas.height = 300;
  }

testthings(){
   this.setText ='8';
 // this.BackgroundImage('../../assets/chalkboards/chalkboardBlack300x300.png');
}

public get getCanvas(): HTMLCanvasElement{
 return papercanvas;
}

  public set setText(mytext: string) {

this.removeText();
 
var pointTextLocation = new paper.Point(20,20);
    var text = new paper.PointText({
            //point: paper.view.center,
            point: pointTextLocation,
      content: mytext,
      //justification: 'center',
      fillColor: 'white'      
      //fontSize: 60
    });
    text.name = this.textname;
    // text.fitBounds(new paper.Rectangle(new paper.Point(0,0),new paper.Point(papercanvas.width,papercanvas.height)));
    //text.fitBounds(new paper.Rectangle(new paper.Point(0,0),new paper.Point(300,200)));
  }

public removeText(){
try {
  var mychildren = paper.project.activeLayer.children;
    var mychild =mychildren[this.textname];
    console.log('mychild: ' + (<paper.PointText>mychild).content);
    (<paper.PointText>mychild).remove();
} catch (error) {
  console.log('settext mychild.remove: ' + error)
}
}

// public BackgroundImage(myurl:string){
// let backgroundlayer = new paper.Layer();
// let p = new paper.Point(300,150)
// var raster = new paper.Raster(myurl, p);

// }

public fitText(x1:number, y1:number, x2:number, y2: number){
  var mychildren = paper.project.activeLayer.children;
    var mychild =mychildren[this.textname];
    console.log('mychild: ' + (<paper.PointText>mychild).content);
    (<paper.PointText>mychild).fitBounds(new paper.Rectangle(new paper.Point(x1,y1),new paper.Point(x2,y2)));
}

  /**
   * Je nach Inputtype werden die entsprechenden Events verbunden
   * 
   * @memberof UipaperComponent
   */
  addEvents() {

    switch (this.inputtyp) {
      case InputType.MOUSE:
        papercanvas.addEventListener('mousedown', this.mousedownEvent);
        papercanvas.addEventListener('mousemove', this.mousedragEvent);
        papercanvas.addEventListener('mouseup', this.mouseupEvent);
        papercanvas.addEventListener('mouseout', this.mouseoutEvent);
        break;
      case InputType.TOUCH:
        papercanvas.addEventListener('touchstart', this.touchstartEvent);
        papercanvas.addEventListener('touchmove', this.touchmoveEvent);
        papercanvas.addEventListener('touchend', this.touchendEvent);
        break;
      default:
        throw 'Inputtype nicht bekannt'
    }

  }




  /**
   * Behandelt mousedown event
   * Hier wird Style der Linie zugewiesen, der neue Pfad erstellt unbd der erste Punkt gesetzt
   * @param {any} event 
   * @memberof UipaperComponent
   */
  mousedownEvent(event) {

    //Set  flag to detect mouse drag
    drag = true;
    path = new paper.Path();
    // path.strokeColor = 'black';
    path.style = {
      //fillColor: 'blue',
      strokeColor: 'red',
      strokeWidth: 10,
      strokecap: 'round'
    };
    path.add(new paper.Point(event.layerX, event.layerY));

    console.log("downevent sucess:" + "layerX" + event.layerX + "layerY" + event.layerY)
  }




  /**
   * Behandelt wenn mousemove event
   * Hier wird der Pfad gezeichnet
   * @param {any} event 
   * @memberof UipaperComponent
   */
  mousedragEvent(event) {

    if (drag) {
      path.add(new paper.Point(event.layerX, event.layerY));
      path.smooth();
    }
    console.log("dragevent sucess:" + "layerX" + event.layerX + "layerY" + event.layerY);
  }



  /**
   * Behandelt mouseup event
   * Drag wird auf false gestetztt, dadurch wird nicht weiter gezeichnet
   * @param {any} event 
   * @memberof UipaperComponent
   */
  mouseupEvent(event) {

    //Clear Mouse Drag Flag
    drag = false;


    console.log("Upevent sucess:" + "layerX" + event.layerX + "layerY" + event.layerY);

  }


  /**
   * Behandelt mouseout Event 
   * Wenn die Maus das Canvas verlässt wird zeichen abgebrochen
   * @param {any} event$ 
   * @memberof UipaperComponent
   */
  mouseoutEvent(event$) {
    console.log("mouse out of element")
    drag = false;
  }


 //Beginn: Das funktioniert mit dem Finger
 
  //wenn touchstart, dann
  touchstartEvent(event: TouchEvent) {
   
    console.log("touchstartEvent")
    //Set  flag to detect  drag
    drag = true;
    path = new paper.Path();
    // path.strokeColor = 'black';
    path.style = {
      //fillColor: 'blue',
      strokeColor: 'red',
      strokeWidth: 10,
      strokecap: 'round'
    };

    
    var b = papercanvas.getBoundingClientRect();
var x: number;
    x = event.changedTouches[0].pageX - b.left;

var y: number;
    // var b = papercanvas.getBoundingClientRect();

    y = event.changedTouches[0].pageY - b.top;


path.add(new paper.Point(x, y));

console.log("touchmoveEvent:" + "pageX" + event.changedTouches[0].pageX + "getXCoordinate " + x + "; pageY" + event.changedTouches[0].pageY + "getYCoordinate " +y);

  }

  //wenn touchmove bewegt wird
  touchmoveEvent(event: TouchEvent) {
    console.log("touchmoveEvent");


    var b = papercanvas.getBoundingClientRect();
var x: number;
    x = event.changedTouches[0].pageX - b.left;

var y: number;
    // var b = papercanvas.getBoundingClientRect();

    y = event.changedTouches[0].pageY - b.top;


if (drag) {
                    path.add(new paper.Point(x, y));
                    path.smooth();
                }

console.log("touchmoveEvent:" + "pageX" + event.changedTouches[0].pageX + "getXCoordinate " + x + "; pageY" + event.changedTouches[0].pageY + "getYCoordinate " +y);
    
  }

  //wenn touchend, dann
  touchendEvent(event: TouchEvent) {
    
    //Clear Mouse Drag Flag
    drag = false;

console.log("touchendEvent: " + "pageX: " + event.changedTouches[0].pageX  + "; pageY" + event.changedTouches[0].pageY );

 //this.strokeAdded.emit('strokeadded');
 
this.myevents.publish('strokeAddedEvent', Date.now());
  }

  //! todo Das geht noch nicht
  focusoutEvent(event) {
    console.log("focusoutEvent")
    document.getElementById('message').innerHTML = "focusoutEvent";
    drag = false;
  }

  //Ende Das funktioniert mit dem Finger



  //alles, bis auf view, löschen
  clearPapercanvas() {


try {
  var mychildren = paper.project.activeLayer.children;
  mychildren.forEach(element => {
    if(element!=mychildren[this.textname])
    element.remove()
  });
    
} catch (error) {
  console.log('clearPapaercanvas: ' + error)
}

    //paper.project.activeLayer.removeChildren();
    //neu zeichnen
    paper.view.draw();
  }


  public test() {
   

    this.setText = '12';

  }
}


// WEBPACK FOOTER //
// ./src/components/uipaper/uipaper.ts